import React from 'react';
import { MinusBlue, PlusBlue } from '../assets';
import s from './index.module.scss';

export const Counter = ({ onChangeCounter, onPlus, onMinus, counter }) => {
    return (
        <div className={s.productInfoModalCounterWrap}>
            <MinusBlue onClick={onMinus} className={s.productInfoModalIcon} />
            <input
                value={counter}
                onChange={onChangeCounter}
                type="text"
                className={s.productInfoWrapCounter}
            />
            <PlusBlue onClick={onPlus} className={s.productInfoModalIcon} />
        </div>
    );
};
